import React from "react";
import { FormLayout, Modal, Text, TextField } from "@shopify/polaris";

export default function SetAllQuantitiesModal({
  closeSetAllQuantitiesModal,
  setAllQuantitiesModalOpen,
  setAllQuantities,
  allQuantity,
  handleSetAllQuantitiesChange,
}: {
  readonly closeSetAllQuantitiesModal: () => void;
  readonly setAllQuantitiesModalOpen: boolean;
  readonly setAllQuantities: (quantity: number) => void;
  readonly allQuantity: number;
  readonly handleSetAllQuantitiesChange: (value: string) => void;
}): React.ReactElement {
  return (<Modal
    onClose={closeSetAllQuantitiesModal}
    open={setAllQuantitiesModalOpen}
    primaryAction={{
      content: "Set all",
      onAction: () => {
        setAllQuantities(allQuantity);
        closeSetAllQuantitiesModal();
      },
    }}
    secondaryActions={[{ content: "Cancel", onAction: closeSetAllQuantitiesModal }]}
    title="Set all variant order quantities"
  >
    <Modal.Section>
      <FormLayout>
        <Text as="p">Increase the quantity of the recommendations by a percentage and / or a fixed quantity.</Text>
        <FormLayout.Group>
          <TextField
            autoComplete="off"
            label="Order quantity"
            onChange={handleSetAllQuantitiesChange}
            suffix="pieces"
            value={allQuantity?.toString() || ""}
          />
        </FormLayout.Group>
      </FormLayout>
    </Modal.Section>
  </Modal>);
};
